import React, { Component } from "react";
import { FieldArray } from "redux-form";
import { Row, Col } from "react-bootstrap";
import _ from "lodash";

import Box from "./Box";
import { RemoveButton } from "./AddBox/RemoveButton";
import { AddButton } from "./AddBox/AddButton";
import styles from "./CompleteProfile.scss";

export default class AddBox extends Component {
  constructor(props) {
    super(props);
  }

  renderBox = ({ fields, meta: { touched, error } }) => {
    if (_.isEmpty(fields.getAll())) {
      fields.push({});
    }

    return (
      <ul style={{ listStyleType: "none", padding: 0, margin: 0 }}>
        {fields
          .map((box, index) => {
            return { box, index };
          })
          .filter(field => {
            let fieldValue = fields.get(field.index);
            return fieldValue && !fieldValue.remove;
          })
          .map(({ box, index }) => (
            <li key={index}>
              <Row className={styles.box}>
                <Col xs={12} className={styles.boxPadding}>
                  <Box
                    allowNew={this.props.allowNew}
                    change={this.props.change}
                    focusOut={this.props.focusOut}
                    inputCompanyName={`${box}[0].company_name`}
                    inputName={`${box}[0].${this.props.inputName}`}
                    inputNameExtra={`${box}[0].${this.props.inputNameExtra}`}
                    isLoading={this.props.isLoading}
                    labelKey={this.props.labelKey}
                    name={`${box}`}
                    noPaddingRight={this.props.noPaddingRight}
                    options={this.props.options}
                    placeholder={this.props.placeholder}
                    placeholderTypeahead={this.props.placeholderTypeahead}
                    prefix={this.props.prefix}
                    selected={
                      (this.props.selectOpts && this.props.selectOpts[index]) ||
                      false
                    }
                    showYearsWorked={this.props.showYearsWorked}
                    subtitle={this.props.subtitle}
                    text={this.props.text}
                    title={this.props.title}
                    typeahead={this.props.typeahead}
                    valueKey={this.props.valueKey}
                    onSearch={query => this.props.onSearch(query)}
                  />
                </Col>
                {fields.length > 1 && (
                  <RemoveButton fields={fields} index={index} />
                )}
              </Row>
            </li>
          ))}

        <AddButton addText={this.props.addText} fields={fields} />
        {touched && error && <span>{error}</span>}
      </ul>
    );
  };

  render() {
    return (
      <React.Fragment>
        <div className={styles.sectionTitle}>{this.props.title}</div>

        <div className={styles.sectionDescription}>{this.props.subtitle}</div>

        <FieldArray name={this.props.name} component={this.renderBox} />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/candidate/completeProfile/components/AddBox.js